import makeStyles from "@mui/styles/makeStyles";
import {useDispatch, useSelector} from 'react-redux';
import {
    getMarkedOperation,
    reload,
    setMarkedOperation,
} from '../../../../store/reducers/booked_admissions';
import React, {useEffect} from 'react';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import moment from "moment";
import API from '../../../../app/api';
import * as _ from 'lodash';
import AgyleTextField from '../../../../components/ui/fields/agyleTextField';
import Grid from '@mui/material/Grid';
import AgyleDatePicker from '../../../../components/ui/fields/agyleDatePicker';
import AgyleSelectField from '../../../../components/ui/selector/agyleSelectField';
import MenuItem from '@mui/material/MenuItem';
import config from "../../../../app/config"
import {user} from '../../../../store/reducers/user';
import uuidv4 from 'uuid/v4';
import {InputLabel, Select, TextField} from '@mui/material';
import FormControl from '@mui/material/FormControl';

export const useStyles = makeStyles((theme) => ({
    textFieldClass: {
        backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#ebebeb",
        border: "1px solid #5f5f5f",
        borderRadius: 4
    },
}));



const AddInformationModal = (props) => {

    const classes = useStyles();
    const markedOperation = useSelector(getMarkedOperation);
    const controller = new AbortController();
    const dispatch = useDispatch();


    const [data, setData] = React.useState({...props.model.object, ...props.row})
    const userObject = useSelector(user);

    useEffect(() => {
        if(userObject) {
            setData((formData) => ({
                ...formData,
                user: `${userObject.firstName} ${userObject.familyName}`
            }));
        }
    },[userObject]);

    useEffect(()=>{
        if(!props.row)
            setData((formData) => ({
                ...formData,
                id: uuidv4() + "",
                date: moment()
            }));

    }, [])

    const renderCustomOption = (opt) => {
        return (
            <MenuItem
                key={opt.description}
                value={opt.value}
            >
                {opt.description}
            </MenuItem>
        );
    };

    const handleChange = (value, type) => {
        setData((formData) => ({
            ...formData,
            [type]: value,
        }));

    };

    const handleSave = () => {

        let operationTmp = _.cloneDeep(markedOperation);

        if (props.row) {
            const index = _.findIndex(operationTmp[props.model.source], el => el.id === props.row.id);
            operationTmp[props.model.source][index] = data;
        } else {
            operationTmp[props.model.source] = operationTmp[props.model.source] || [];
            operationTmp[props.model.source].push(data);
        }


        let patientTmp = operationTmp["patient"]
        let sessiosObjTmp = operationTmp["sessiosObj"];

        delete operationTmp.sessiosObj;
        delete operationTmp.href;
        delete operationTmp.type;
        delete operationTmp.patient;


        if(operationTmp.overseeingConsultant) {
            operationTmp.overseeingConsultant = {
                id: operationTmp.overseeingConsultant.id,
                name: operationTmp.overseeingConsultant.name,
            }
        }


        API.admissionUpdate(operationTmp, controller.signal).then(
            (res) => {
                dispatch(reload());
                dispatch(setMarkedOperation({
                    ...res,
                    patient: patientTmp,
                    sessiosObj: sessiosObjTmp
                }));
                if(props.onClose) props.onClose();
            }
        )
    }

    return (<Grid container spacing={2}>
        {props.model.tableColumns.map((column)=>{
            let columnRender;

            switch(column.format) {
                case "string":
                    columnRender = <TextField
                        label={column.label}
                        name={column.field}
                        onChange={(e) => handleChange(e.target.value, column.field)}
                        value={data?.[column.field]}
                        fullWidth
                        multiline
                        size={"small"}
                        disabled={column.disabled}
                    />
                    break;
                case "date":
                    columnRender =  <AgyleDatePicker
                        label={column.label}
                        size={"small"}
                        name={column.field}
                        noBorder={false}
                        inputFormat={config.defaultDateFormat}
                        inputVariant="outlined"
                        value={data?.[column.field]}
                        type="dateTime"
                        onChange={(e) => handleChange(e, column.field)}
                    />
                    break;
                case "status":
                    columnRender = <AgyleSelectField
                        onChange={(e) => handleChange(e, column.field)}
                        name={column.field}
                        label={column.label}
                        options={props.model.statusTypes}
                        value={data?.[column.field]}
                        withBorder
                        padding={"10px"}
                        defaultClearValue="both"
                        customObject={renderCustomOption}
                        clearButtonVisible={false}
                    />
                    break;
                case "source":
                    columnRender = <AgyleSelectField
                        onChange={(e) => handleChange(e, column.field)}
                        name={column.field}
                        label={column.label}
                        options={props.model.sourceTypes}
                        value={data?.[column.field]}
                        withBorder
                        padding={"10px"}
                        defaultClearValue="both"
                        customObject={renderCustomOption}
                        clearButtonVisible={false}
                    />
                    break;
            }
            return <Grid item xs={12}> {columnRender} </Grid>;
        })}
        <Grid item xs = {12}>
            <AgyleButton
                style={{float: "right"}}
                size="small"
                variant="contained"
                onClick={handleSave}>
               Save
            </AgyleButton>
        </Grid>
    </Grid>)
}

export default AddInformationModal